<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header p-0">
      <a
        href="#"
        onClick="return false;"
        class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed"
        aria-expanded="false"
      ></a>
      <a
        href="#"
        onClick="return false;"
        class="bars"
        (click)="mobileMenuSidebarOpen($event, 'overlay-open')"
      ></a>
      <a class="m-0 navbar-brand p-0" routerLink="{{ homePage }}">
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button
            mat-icon-button
            (click)="callSidemenuCollapse()"
            class="sidemenu-collapse"
          >
            <mat-icon>menu</mat-icon>
          </button>
          <span>WELCOME TO HILLTOP PHARMACY</span>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li class="nav-item" ngbDropdown>
          <button
            mat-icon-button
            ngbDropdownToggle
            class="nav-notification-icons"
          >
            <mat-icon>notifications_none</mat-icon>
            <span class="label-count bg-orange rounded-circle"
              >{{unreadCount}}</span
            >
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div
              class="noti-list p-6"
              style="
                position: relative;
                max-width: 600px;
                max-height: 250px;
                border-radius: 10px;
              "
              [perfectScrollbar]
            >
              <ul class="menu">
                <li>
                  <a
                    *ngFor="let notification of notifications"
                    (click)="UpdateNotification(notification)"
                    style="cursor: pointer;"
                    [class.unreadNotification]="!notification.IsRead"
                    [class.alert-light]="notification.IsRead"
                    class="border-bottom-notification"
                  >
                    <span class="menu-info">
                      <span>
                        <!-- <span class="menu-title">{{ notification.Title }}</span> -->
                      </span>
                      <span *ngIf="notification.IsRead" class="col-9 menu-desc"
                        >{{ notification.Description }}</span
                      >
                      <span *ngIf="!notification.IsRead" class="col-9 menu-desc" 
                        ><b>{{ notification.Description }}</b></span
                      >
                      <span class="col-3 menu-desc">
                        <i class="material-icons">access_time</i>
                        {{ timeSince(notification.CreatedDate) }}
                      </span>
                    </span>
                  </a>
                </li>
                <li>
                  <a [hidden]="notifications?.length!=0">
                    No notification to display.
                  </a>
                </li>
              </ul>
            </div>
            <!-- <a
              class="text-center d-block border-top py-1"
              [hidden]="notifications.length!=0"
              >No notification to display.</a
            > -->
          </div>
        </li>
        <!-- #END# Notifications-->
        <li
          class="nav-item justify-content-end user_profile d-flex align-items-baseline"
          ngbDropdown
        >
          <span class="badge bg-welcome-header me-2 rounded-pill p-2 text-capitalize"
            >Welcome
            <strong
              ><span *ngIf="userAccount?.UserRoleId == 2">Dr.&nbsp;</span>{{
              userFullName }}</strong
            >
          </span>
          <a
            href="#"
            onClick="return false;"
            ngbDropdownToggle
            role="button"
            class="nav-notification-icons pt-0 js-right-sidebar"
          >
            <img
              *ngIf="userAccount?.ProfilePictureId==null && userAccount?.UserRoleId != 2"
              src="{{'../assets/images/user/user-1.png'}}"
              class="rounded-circle"
              width="32"
              height="32"
              alt="User"
            />
            <img
              *ngIf="userAccount?.ProfilePictureId==null && userAccount?.UserRoleId == 2"
              src="{{'../assets/images/user/dr.png'}}"
              class="rounded-circle"
              width="32"
              height="32"
              alt="User"
            />
            <span
              *ngIf="userAccount?.ProfilePictureId!=0 && userAccount?.ProfilePictureId!=null"
            >
              <app-profile-pic
                [userType]="userType"
                [type]="'thumb'"
                [documentId]="userAccount?.ProfilePictureId"
              ></app-profile-pic>
            </span>
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div
              class="noti-list"
              style="position: relative; max-width: 600px; max-height: 300px;"
              [perfectScrollbar]
            >
              <ul class="menu custom-dialog-css"> 
                <li class="body">
                  <ul class="user_dw_menu">
                    <li ngbDropdownItem [hidden]="userRole !== 'Pharmacist'">
                      <a
                        href="#"
                        [routerLink]="['/pharmacist/pharmacy']"
                        routerLinkActive="router-link-active"
                        onClick="return false;"
                      >
                        <mat-icon aria-hidden="false" class="me-2"
                          >business</mat-icon
                        >Pharmacy Profile
                      </a>
                    </li>
                    <li ngbDropdownItem [hidden]="userRole === 'Pharmacist'">
                      <a
                        href="#"
                        [routerLink]="['/doctor/profile']"
                        routerLinkActive="router-link-active"
                        onClick="return false;"
                      >
                        <mat-icon aria-hidden="false" class="me-2"
                          >person</mat-icon
                        >My Profile
                      </a>
                    </li>
                    <li ngbDropdownItem [hidden]="userRole !== 'Pharmacist'">
                      <a
                        href="#"
                        [routerLink]="['/pharmacist/profile']"
                        routerLinkActive="router-link-active"
                        onClick="return false;"
                      >
                        <mat-icon aria-hidden="false" class="me-2"
                          >person</mat-icon
                        >My Profile
                      </a>
                    </li>
                    <!-- <li [hidden]="userRole !== 'Pharmacist'">
                      <a
                        href="#"
                        [routerLink]="['/pharmacist/profile/edit']"
                        routerLinkActive="router-link-active"
                        onClick="return false;"
                      >
                        <mat-icon aria-hidden="false" class="me-2">
                          edit
                        </mat-icon>
                        Edit Profile
                      </a>
                    </li> -->
                    <li ngbDropdownItem [hidden]="userRole === 'Pharmacist'">
                      <a
                        href="#"
                        [routerLink]="['/doctor/profile/edit']"
                        routerLinkActive="router-link-active"
                        onClick="return false;"
                      >
                        <mat-icon aria-hidden="false" class="me-2">
                          edit
                        </mat-icon>
                        Edit Profile
                      </a>
                    </li>
                    <li ngbDropdownItem>
                      <a
                        href="#"
                        onClick="return false;"
                        [routerLink]="['/doctor/profile/change-password']"
                        routerLinkActive="router-link-active"
                      >
                        <mat-icon aria-hidden="false" class="me-2"
                          >lock</mat-icon
                        >Change Password
                      </a>
                    </li>
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="me-2"
                          >help</mat-icon
                        >Help
                      </a>
                    </li> -->
                    <li ngbDropdownItem>
                      <a href="javascript:void(0);" (click)="logout()">
                        <mat-icon aria-hidden="false" class="me-2"
                          >power_settings_new</mat-icon
                        >Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
        <!-- <li class="pull-right">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons js-right-sidebar">
            <mat-icon id="settingBtn">settings</mat-icon>
          </button>
        </li> -->
      </ul>
    </div>
  </div>
</nav>
